import React from "react";
import { AdminRoute } from "../../AdminRoute";
import KnowledgeBasePage from "../KnowledgeBasePage";

export const KnowledgeBase: React.FC = () => {
    return (
        <AdminRoute>
            <KnowledgeBasePage />
        </AdminRoute>
    );
};
